export * from './phone-mask';
export * from './cep.mask';
export * from './card-expiry.mask';
export * from './card-number.mask';
export * from './cpf.mask';

export const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
